import { render, staticRenderFns } from "./ProcessedArea.vue?vue&type=template&id=249f7576&lang=pug"
import script from "./ProcessedArea.vue?vue&type=script&lang=js"
export * from "./ProcessedArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports